export default __webpack_public_path__ + "static/media/cat3-4.bd691d30.jpg";